import { render, staticRenderFns } from "./HomeModuleConfig.vue?vue&type=template&id=1f2dd3ce&scoped=true"
import script from "./HomeModuleConfig.vue?vue&type=script&lang=js"
export * from "./HomeModuleConfig.vue?vue&type=script&lang=js"
import style0 from "./HomeModuleConfig.vue?vue&type=style&index=0&id=1f2dd3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2dd3ce",
  null
  
)

export default component.exports